<script setup lang="ts">
import { ErrorPage } from '#layers/ui/public';
</script>

<template>
	<ErrorPage />
</template>
